(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["athletes-carousel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll(".ath-carousel").forEach(function (root) {
    var track = root.querySelector("[data-ath-track]");
    var dots = root.querySelectorAll("[data-ath-dot]");
    if (!track || dots.length === 0) return;

    dots.forEach(function (dot) {
      dot.addEventListener("click", function () {
        var index = parseInt(dot.getAttribute("data-ath-dot"), 10);
        var slide = track.querySelectorAll("[data-ath-slide]")[index];
        if (slide) {
          track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: "smooth" });
        }
      });
    });

    track.addEventListener("scroll", function () {
      var slides = track.querySelectorAll("[data-ath-slide]");
      var center = track.scrollLeft + track.clientWidth / 2;
      var active = 0;
      var best = Number.MAX_VALUE;
      slides.forEach(function (slide, index) {
        var slideCenter = slide.offsetLeft - track.offsetLeft + slide.clientWidth / 2;
        var distance = Math.abs(slideCenter - center);
        if (distance < best) { best = distance; active = index; }
      });
      dots.forEach(function (dot, index) {
        dot.classList.toggle("is-active", index === active);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
